import { createFileRoute } from "@tanstack/react-router";
import { kennelTasksRoute, KennelTasksPage } from "@/features/provider-home";

export const Route = createFileRoute("/kennel/_dashboard/tasks")({
    ssr: kennelTasksRoute.ssr,
    head: kennelTasksRoute.head,
    component: KennelTasksPage,
});
